import script from "./it.vue?vue&type=script&lang=js"
export * from "./it.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__